/**
 * ew-product-details — opens the Product Details panel as a full-screen popup.
 *
 * The buy box's "View Details" pill (blocks/ew-product-accordion.liquid) ships `hidden`.
 * This reveals it only once a dialog actually exists on the page, so the control can never
 * be a dead button: with this section absent, or with its popup setting off, or with JS
 * off, the pill simply is not there and the panel below the fold carries the same content.
 *
 * <dialog>.showModal() gives the focus trap, ESC-to-close, inertness of the rest of the
 * page and return-focus to the trigger for free. Only backdrop-click has to be added, and
 * that is one comparison against the dialog's own box.
 */
(() => {
  const SELECTOR_DIALOG = '.ew-pd__dialog';
  const SELECTOR_OPEN = '[data-ew-product-details-open]';
  const SELECTOR_CLOSE = '[data-ew-product-details-close]';

  const dialogFor = (node) => {
    // A PDP has one of these. If a page ever grew two, the nearest one after the trigger
    // is the right one; falling back to the first keeps a single-dialog page working.
    const all = document.querySelectorAll(SELECTOR_DIALOG);
    if (all.length <= 1) return all[0] || null;
    for (const dialog of all) {
      if (node.compareDocumentPosition(dialog) & Node.DOCUMENT_POSITION_FOLLOWING) return dialog;
    }
    return all[0];
  };

  const wire = () => {
    const dialogs = document.querySelectorAll(SELECTOR_DIALOG);
    if (!dialogs.length) return;

    for (const dialog of dialogs) {
      if (dialog.dataset.ewWired === 'true') continue;
      dialog.dataset.ewWired = 'true';

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        // A click on the dialog element itself is a click on the backdrop area, because
        // every visible child sits inside .ew-pd__dialog-inner.
        dialog.close();
      });

      for (const close of dialog.querySelectorAll(SELECTOR_CLOSE)) {
        close.addEventListener('click', () => dialog.close());
      }
    }

    for (const trigger of document.querySelectorAll(SELECTOR_OPEN)) {
      if (trigger.dataset.ewWired === 'true') continue;

      const dialog = dialogFor(trigger);
      if (!dialog || typeof dialog.showModal !== 'function') continue;

      trigger.dataset.ewWired = 'true';
      trigger.hidden = false;
      trigger.addEventListener('click', () => dialog.showModal());
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire, { once: true });
  } else {
    wire();
  }

  // The theme editor re-renders sections in place, which replaces both the dialog and the
  // trigger. Re-wiring is idempotent thanks to the data-ew-wired guard.
  document.addEventListener('shopify:section:load', wire);
  document.addEventListener('shopify:block:select', wire);
})();
